/* eslint-disable */
import React, { Component } from 'react';

import { gravatar, initials } from '../base/avatar.api';

class Avatar extends Component {
    constructor (props) {
        super(props);
        this.state = {
            hasGravatar: false,
            gravatarUrl: '',
            class: this.props.class || '',
            isMounted: false
        };
        this.title = (props.name
            ? props.name + '\n' + props.email
            : props.email) +
            (props.login ? `\n(${props.login})` : '');
        this.initials = initials.get(props);
    }

    componentDidMount () {
        this.setState({ isMounted: true });
        if (this.props.email) {
            gravatar.get(this.props.email)
                .then(url => {
                    if (this.state.isMounted) {
                        this.setState({
                            gravatarUrl: url,
                            hasGravatar: true
                        });
                    }
                },
                    error => {
                        if (this.state.isMounted) {
                            this.setState({ hasGravatar: false });
                        }
                    });
        } else {
            this.setState({ hasGravatar: false });
        }
    }

    componentWillUnmount () {
        this.setState({ isMounted: false });
    }

    renderGravatar = () =>
        (<div
            className={`avatar ${this.state.class}`}
            title={this.title}
            style={{ backgroundImage: `url(${this.state.gravatarUrl})` }}
        ></div>);

    renderInitials = () =>
        (<div
            className={`avatar ${!this.props.name ? 'no-account-avatar' : ''}${this.state.class}`}
            title={this.title}
            style={{ backgroundColor: this.initials.color }}
        >
            { this.initials.initials }
        </div>);

    render () {
        return this.state.hasGravatar
            ? this.renderGravatar()
            : this.renderInitials();
    }
}

export default Avatar;

/* eslint-enable */
